import Vue from 'vue';
import Utils from '~/plugins/Utils.js';

export default () => {
    Vue.use(Utils, {
        base_url: process.env.API_BASE_URL
    });
};
